import { isLocalApi } from 'utils/localApi';

// Set REACT_APP_LOCAL_API_NON_CONFORMANCE_REPORTS=true in .env.local for the local API.
export const NON_CONFORMANCE_REPORTS_LOCAL_API_REQUESTS = isLocalApi(
  process.env.REACT_APP_LOCAL_API_NON_CONFORMANCE_REPORTS
);
